import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

import { PageHeader } from "@/components/common/page-header"
import { TriageTable } from "@/features/issues/components/triage-table"
import { issueQueries } from "@/queries/issues"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/_main/triage/"
)({
  validateSearch: z.object({ page: z.number().int().positive().optional() }),
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) =>
    context.queryClient.ensureQueryData(
      issueQueries.list({ status: "triage", page: deps.page })
    ),
  component: TriagePage,
})

function TriagePage() {
  const { page } = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <>
      <PageHeader title="Triage" />
      <TriageTable
        page={page}
        onPageChange={(next) => void navigate({ search: { page: next } })}
      />
    </>
  )
}
